/* remente custom injectors — earn-points / labels / sale-badge / shipping-badge
 * Loaded as defer external on product pages only.
 * Reads product context from <script type="application/json" id="remente-product-data">.
 */
(function() {
  var dataEl = document.getElementById('remente-product-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var tags = Array.isArray(data.tags) ? data.tags : [];
  var productPrice = typeof data.productPrice === 'number' ? data.productPrice : 0;
  var pointRate = typeof data.pointRate === 'number' ? data.pointRate : 0.03;
  var shippingThresholdYen = typeof data.shippingThresholdYen === 'number' ? data.shippingThresholdYen : 3980;

  var injected = false;
  var pointsInjected = false;
  var lastCartTotalYen = null;

  /* ポイント付与の対象外にする商品タグ。
   * どこポイのカスタム還元率設定「除外」ルールと同じタグを指定すること。
   * 実際には付与されないため、獲得ポイントの表示も出さない。 */
  /* 2026-10-25 ポイント対象外 を追加（リトルサイエンティスト・ReKERA の全商品に付いている。どこポイの除外ルールと同じタグ） */
  var NO_POINT_TAGS = ['RE:MEMBERS', 'ポイント対象外'];

  function isNoPointProduct() {
    return tags.some(function(tag) {
      return NO_POINT_TAGS.indexOf(tag) !== -1;
    });
  }

  var colorMap = {
    '人気':             'popular',
    'POPULAR':          'popular',
    '期間限定':         'limited',
    '送料無料':         'limited',
    '特別価格':         'special',
    'ギフト可':         'special',
    '店頭受け取り限定': 'store',
    'mens':             'mens',
    'MENS':             'mens',
    'メンズ':           'mens',
    'ladies':           'ladies',
    'LADIES':           'ladies',
    'レディース':       'ladies',
    'NO.1':             'gold',
    'NO.2':             'silver',
    'NO.3':             'bronze'
  };

  function buildLabels() {
    var html = '';
    tags.forEach(function(tag) {
      var text = null;
      if (tag.indexOf('label-detail:') === 0) {
        text = tag.replace('label-detail:', '').trim();
      } else if (tag.indexOf('label-top:') === 0) {
        return;
      } else if (tag.indexOf('label:') === 0) {
        text = tag.replace('label:', '').trim();
      }
      if (!text) return;
      var color = colorMap[text] || 'default';
      html += '<span class="product-label product-label--' + color + ' product-label--detail">' + text + '</span>';
    });
    return html;
  }

  function buildEarnPoints() {
    if (isNoPointProduct()) return '';
    if (!productPrice || productPrice <= 0) return '';
    var pts = Math.floor((productPrice / 100) * pointRate);
    if (pts <= 0) return '';
    return '<div class="product-single__earn-points">' +
           '<span class="product-single__earn-points-icon" aria-hidden="true">🎁</span>' +
           '<span class="product-single__earn-points-text">＋' + pts.toLocaleString() + 'ポイント獲得</span>' +
           '</div>';
  }

  function injectEarnPoints() {
    if (pointsInjected) return;
    var html = buildEarnPoints();
    if (!html) return;
    var priceEl = document.querySelector('[data-pf-type="ProductPrice2"]')
               || document.querySelector('[data-product-price="true"]')
               || document.querySelector('.block-price__container');
    if (!priceEl) return;
    var anchor = priceEl;
    for (var i = 0; i < 3; i++) {
      var p = anchor.parentNode;
      if (!p) break;
      var cs = window.getComputedStyle(p);
      var isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
      var isRow = cs.flexDirection === 'row' || cs.flexDirection === 'row-reverse' || cs.flexDirection === '';
      if (!isFlex || !isRow) break;
      anchor = p;
    }
    if (anchor.parentNode.querySelector('.product-single__earn-points')) {
      pointsInjected = true;
      return;
    }
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    anchor.parentNode.insertBefore(wrapper.firstChild, anchor.nextSibling);
    pointsInjected = true;
  }

  function buildShippingBadge() {
    if (tags.indexOf('送料無料') !== -1) {
      return '<div class="product-single__shipping-badge product-single__shipping-badge--free">' +
             '<span class="product-single__shipping-badge-icon" aria-hidden="true">✓</span>' +
             '<span class="product-single__shipping-badge-text">この商品は送料無料</span>' +
             '</div>';
    }
    if (lastCartTotalYen === null) {
      return '<div class="product-single__shipping-badge product-single__shipping-badge--info">' +
             '<span class="product-single__shipping-badge-icon" aria-hidden="true">🚚</span>' +
             '<span class="product-single__shipping-badge-text">¥' + shippingThresholdYen.toLocaleString() + '（税込）以上で送料無料（北海道・沖縄は¥440）</span>' +
             '</div>';
    }
    if (lastCartTotalYen >= shippingThresholdYen) {
      return '<div class="product-single__shipping-badge product-single__shipping-badge--free">' +
             '<span class="product-single__shipping-badge-icon" aria-hidden="true">✓</span>' +
             '<span class="product-single__shipping-badge-text">送料無料の対象です（本州・四国・九州）</span>' +
             '</div>';
    }
    if (lastCartTotalYen > 0) {
      var remain = shippingThresholdYen - lastCartTotalYen;
      return '<div class="product-single__shipping-badge product-single__shipping-badge--progress">' +
             '<span class="product-single__shipping-badge-icon" aria-hidden="true">🚚</span>' +
             '<span class="product-single__shipping-badge-text">あと¥' + remain.toLocaleString() + 'で送料無料（本州・四国・九州）</span>' +
             '</div>';
    }
    return '<div class="product-single__shipping-badge product-single__shipping-badge--info">' +
           '<span class="product-single__shipping-badge-icon" aria-hidden="true">🚚</span>' +
           '<span class="product-single__shipping-badge-text">¥' + shippingThresholdYen.toLocaleString() + '（税込）以上で送料無料（北海道・沖縄は¥440）</span>' +
           '</div>';
  }

  function injectShippingBadge() {
    var html = buildShippingBadge();
    if (!html) return;
    var existing = document.querySelector('.product-single__shipping-badge');
    if (existing) {
      var w = document.createElement('div');
      w.innerHTML = html;
      var newEl = w.firstChild;
      if (existing.outerHTML === newEl.outerHTML) return;
      existing.parentNode.replaceChild(newEl, existing);
      return;
    }
    var anchor = document.querySelector('.product-single__earn-points');
    if (!anchor) {
      var priceEl = document.querySelector('[data-pf-type="ProductPrice2"]')
                 || document.querySelector('[data-product-price="true"]')
                 || document.querySelector('.block-price__container');
      if (!priceEl) return;
      var a = priceEl;
      for (var i = 0; i < 3; i++) {
        var p = a.parentNode;
        if (!p) break;
        var cs = window.getComputedStyle(p);
        var isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
        var isRow = cs.flexDirection === 'row' || cs.flexDirection === 'row-reverse' || cs.flexDirection === '';
        if (!isFlex || !isRow) break;
        a = p;
      }
      anchor = a;
    }
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    anchor.parentNode.insertBefore(wrapper.firstChild, anchor.nextSibling);
  }

  function refreshCartTotal() {
    if (tags.indexOf('送料無料') !== -1) return;
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(cart) {
        if (cart && typeof cart.total_price === 'number') {
          lastCartTotalYen = Math.floor(cart.total_price / 100);
          injectShippingBadge();
        }
      })
      .catch(function() {});
  }

  function buildSaleBadge() {
    var badgeNum = null;
    tags.forEach(function(tag) {
      if (tag.indexOf('sale-badge:') === 0) {
        badgeNum = tag.replace('sale-badge:', '').trim();
      }
    });
    if (!badgeNum) return '';
    return '<div class="product-single__sale-badge-row"><span class="product-page__discount-badge">最大' + badgeNum + '%OFF</span></div>';
  }

  function inject() {
    if (injected) return;
    var titleEl = document.querySelector('[data-pf-type="ProductTitle"]');
    if (!titleEl) return;
    var labels = buildLabels();
    var saleBadge = buildSaleBadge();
    if (!labels && !saleBadge) return;
    injected = true;
    if (labels) {
      var wrapper = document.createElement('div');
      wrapper.className = 'product-single__labels';
      wrapper.style.marginBottom = '0.5em';
      wrapper.innerHTML = labels;
      titleEl.parentNode.insertBefore(wrapper, titleEl);
    }
    if (saleBadge) {
      var badgeWrapper = document.createElement('div');
      badgeWrapper.innerHTML = saleBadge;
      titleEl.parentNode.insertBefore(badgeWrapper.firstChild, titleEl.parentNode.querySelector('.product-single__labels') || titleEl);
    }
  }

  function tickAll() {
    inject();
    injectEarnPoints();
    injectShippingBadge();
  }

  function start() {
    tickAll();
    var observer = new MutationObserver(function() {
      tickAll();
      if (injected && pointsInjected) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    refreshCartTotal();
    window.addEventListener('pageshow', refreshCartTotal);
    window.addEventListener('focus', refreshCartTotal);
    ['cart:updated', 'cart:refresh', 'ajaxCart:updated', 'theme:cart:updated'].forEach(function(ev) {
      document.addEventListener(ev, refreshCartTotal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Dedupe pagefly-animation.css link tags (multiple sections render the same CSS) */
(function() {
  function dedupe() {
    var links = document.querySelectorAll('link[href*="pagefly-animation.css"]');
    for (var i = 1; i < links.length; i++) {
      try { links[i].parentNode.removeChild(links[i]); } catch (e) {}
    }
  }
  dedupe();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedupe);
  }
})();
